import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Typography,
  Row,
} from 'antd';

import ModalDeactivatedControls from './ModalDeactivateControls';

const { Text } = Typography;

const ModalDeactivate = ({
  onDeactivate,
  onCancel,
  content,
  open,
  loading,
}) => (
  <Modal
    title={(
      <Row justify="space-between">
        <Text>
          Desactivación
        </Text>
        <ModalDeactivatedControls
          onDeactivate={onDeactivate}
          onCancel={onCancel}
          loading={loading}
        />
      </Row>
    )}
    className="modal-delete"
    open={open}
    footer={null}
    closable={false}
    maskClosable={!loading}
    keyboard={!loading}
    destroyOnClose
  >
    {typeof content === 'string' ? (
      <>
        <Text style={{ fontSize: 16 }}>
          ¿Desea Desactivar
          {' '}
          {content}
          ?
        </Text>
        <Text>
          Se modificará el Historial de Formas de Pago
        </Text>
      </>
    ) : (
      content
    )}
  </Modal>
);

ModalDeactivate.propTypes = {
  onDeactivate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  open: PropTypes.bool,
  loading: PropTypes.bool,
};

ModalDeactivate.defaultProps = {
  open: false,
  loading: false,
};

export default ModalDeactivate;
